import AdsUserReducer from "./reducer";

export const setSignupUser = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.setSignupUser(payload));
};

export const setAdsUserDetails = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.setAdsUserDetails(payload));
};

export const openEmailChangeModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.openEmailChangeModal(payload));
};

export const openEmailVerificationModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.openEmailVerificationModal(payload));
};

export const openProfileCreateModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.openProfileCreateModal(payload));
};

export const closeProfileCreateModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.closeProfileCreateModal(payload));
};

export const closeEmailVerificationModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.closeEmailVerificationModal(payload));
};

export const closeEmailChangeModal = (payload) => (dispatch) => {
  dispatch(AdsUserReducer.actions.closeEmailChangeModal(payload));
};

export const clearAdsUserDetails = () => (dispatch) => {
  dispatch(AdsUserReducer.actions.clearAdsUserDetails());
};

export const clearSignupUser = () => (dispatch) => {
  dispatch(AdsUserReducer.actions.clearSignupUser());
};

export const openSubscriber = () => (dispatch) => {
  dispatch(AdsUserReducer.actions.openSubscriber());
};
export const doneSubcriber = () => (dispatch) => {
  dispatch(AdsUserReducer.actions.doneSubcriber());
};
